// @flow
import * as React from 'react';
import styled from 'styled-components';
import {LayoutWrapper} from 'components/Layout';
import {LocalizedParagraph, LocalizedParagraphFormat, useLocalized} from 'components/Localized';
import LoadingLine from 'components/LoadingLine';
import * as VRUtils from 'utils/vrUtils';

type Props = {
}

export default function Loading(props: Props): React.Element<any> {
  const localized = useLocalized();
  const [loadingRate, setLoadingRate] = React.useState(0);

  React.useEffect(()=>{

    function updateLoadingRate(rate : number) {
      setLoadingRate(rate);
    }
    VRUtils.addVREventListener("loadingRate", updateLoadingRate);

    return ()=>{
      VRUtils.removeVREventListener("loadingRate", updateLoadingRate);
    };
  }, []);


  return (
    <LoadingPage loading={loadingRate}>
      <div>
        <LoadingLine />
        <div>
          <div><LocalizedParagraphFormat format={localized.m_loading_001} args={[Math.floor((loadingRate * 100)).toString()]} /><LocalizedParagraph {...localized.m_loading_002} /></div>
          <LocalizedParagraph {...localized.m_loading_003} />
        </div>
      </div>
    </LoadingPage>
  );
}

const LoadingPage = styled(LayoutWrapper)`
  background-color: rgba(0, 0, 0, 1.0);
  pointer-events: 'auto';

  display:flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;

  > div {
    width: ${(props) => (props.theme.layout.mobile ? 116 : 184)}px;
    height: ${(props) => (props.theme.layout.mobile ? 116 : 184)}px;
    position: relative;

    > svg {
      width: 100%;
      height: 100%;

      #mask001 {
        transform: rotate(${props => -90 + 360 * props.loading}deg);
        transform-origin: center center;
      }
      #mask002 {
        transform: translate(0, ${props => props.loading < 0.5 ? -100 : -100 + 100 * props.loading}%);
        transform-origin: center center;
      }
      #mask003 {
        transform: translate(0, ${props => props.loading < 0.75 ? 100 : 150 * props.loading}%);
        transform-origin: center center;
      }
      #mask004 {
        transform: translate(0, ${props => props.loading < 0.5 ? 0 : -100}%);
        transform-origin: center center;
      }
    }

    > div {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 100%;
      height: 100%;

      display:flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      p {
        display: inline-block;
      }
    }
  }
`;
